export const adminEventImageTranslations = (params: { eventId: number }) => `eventImagesTranslations:${params.eventId}`;
